import { render, staticRenderFns } from "./Precautions.vue?vue&type=template&id=360ec540&scoped=true&"
import script from "./Precautions.vue?vue&type=script&lang=ts&"
export * from "./Precautions.vue?vue&type=script&lang=ts&"
import style0 from "./Precautions.vue?vue&type=style&index=0&id=360ec540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ec540",
  null
  
)

export default component.exports